import { NavType, Sidenav } from '@arsnovasystems/ars-front-lib';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import SupervisorAccountRoundedIcon from '@mui/icons-material/SupervisorAccountRounded';
import { useTranslation } from 'react-i18next';

/**
 * MenuLeft
 *
 * @returns the MenuLeft component
 */
export function MenuLeft() {
  const { t } = useTranslation();
  const nav: NavType = [
    {
      label: t('ik.mainMenu.customers'),
      path: '/',
      Icon: SupervisorAccountRoundedIcon,
      dataAttributes: [
        {
          name: 'tour-selector',
          value: 'menu-customer-accounts',
        },
      ],
    },
    {
      label: t('ik.mainMenu.invoices'),
      Icon: ReceiptLongRoundedIcon,
      path: '/invoices',
      dataAttributes: [
        {
          name: 'tour-selector',
          value: 'menu-invoices',
        },
      ],
    },
    {
      label: t('ik.mainMenu.partnerInfo'),
      Icon: AccountCircleRoundedIcon,
      path: '/partner-info',
      dataAttributes: [
        {
          name: 'tour-selector',
          value: 'menu-partner-info',
        },
      ],
    },
    {
      label: t('ik.mainMenu.meansOfPayments'),
      Icon: CreditCardRoundedIcon,
      path: '/means-of-payments',
      dataAttributes: [
        {
          name: 'tour-selector',
          value: 'menu-means-of-payments',
        },
      ],
    },
  ];

  return <Sidenav nav={nav} />;
}
